module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "clustering-gql.worker.ea31a69adf7eae02af9e.worker.js");
}
